var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMarkupNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90DBF4",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M36.358 23.648c.897.01 2.144.014 3.201.01.541-.002.816-.655.442-1.05-.68-.712-1.624-1.705-2.574-2.702l-2.606-2.738c-.386-.404-1.058-.126-1.058.434v3.425c0 1.437 1.172 2.621 2.595 2.621Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M29.558 33.507h-6.306a1 1 0 1 1 0-2h6.306a1 1 0 0 1 0 2Zm-6.307-7.504h3.292a1 1 0 0 1 0 2H23.25a1 1 0 1 1 0-2Zm10.743 5.819a4.078 4.078 0 0 1 5.565-1.494l1.04.602c.043.024.076.057.116.084V26.13a.58.58 0 0 0-.579-.584h-3.95c-2.354-.013-4.296-1.963-4.296-4.34v-4.185a.593.593 0 0 0-.592-.598h-6.871c-3.203 0-5.803 2.638-5.803 5.86v14.008c0 3.38 2.728 6.122 6.074 6.122h5.778c-.05-.152-.11-.3-.142-.459l-.18-.892a5.248 5.248 0 0 1 .6-3.632l3.24-5.61Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "m39.322 34.975-3.237 5.606c-.19.328-.492.576-.848.699l-.9.275-.179-.896c-.073-.371-.01-.758.18-1.086l3.237-5.608a.411.411 0 0 1 .558-.149l1.04.6a.41.41 0 0 1 .15.559Zm.85-2.291-1.04-.6a2.41 2.41 0 0 0-3.287.881l-3.24 5.61a3.57 3.57 0 0 0-.408 2.474l.178.895a2.025 2.025 0 0 0 2.635 1.524l.868-.295a3.563 3.563 0 0 0 1.939-1.592l3.238-5.608a2.415 2.415 0 0 0-.882-3.289Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkupNotes);
export default __webpack_public_path__ + "static/media/logo-markup-notes.654a0c7160cee9e059bfe37331d0dde5.svg";
export { ForwardRef as ReactComponent };